import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Grid, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { getCar } from 'redux/actions/UserCar';
import { patchUpdateVehicle, postAddVehicle } from 'redux/actions/UserVehicle';
import MoreDetails from 'components/moreDetails/MoreDetails';
import CommonTable from 'components/commonTable/CommonTable';
import Loader from 'components/loader/Loader';
import CommonMultiImageForm from 'components/commonMultiImageForm/CommonMultiImageForm';
import { matrixDriverData } from './MatrixDriverData';
import MatrixDriverVendor from './MatrixDriverVendor';
import { vehicleDialogData } from '../VendorBreadCrumbData';
import VehicleInfo from './VehicleInfo';

function TabDriverVendor(props) {
  const dispatch = useDispatch();
  const companyId = localStorage.getItem("companyId");
  const {state} = useLocation();
  const {id, status,driverId} = state;
  const [selectedImage, setSelectedImage] = useState(null);
  const [showOtherComponent,setShowOtherComponent] = useState(false)
  const [open, setOpen] = useState(false);
  const handleChange = (event, newValue) => {
    props?.handleChange(newValue)
  };
  
  useEffect(() => {
    dispatch(getCar());
  }, [])
 
  const postAddVehicleSuccess = useSelector((state) => state?.userAddVehicle?.userAddVehicle?.success);
  const carList = useSelector((state) => state?.userCar?.userCar?.data);
  const carOption = carList?.body?.map((val, idx) => {
    return { value: val?.id, label: val?.carType, seater: val?.seater };
  });

  const onImageChange = (val) => {
    setSelectedImage(val);
  };

  const onSubmit = (val, code) => {
   
    const data = {
      ...val,
      carType: 'DOC',
      seating: parseInt(val?.seating),
      id: driverId,
      driverId:driverId,
      type: 'driver',
      avtar: selectedImage,
    };
    let formData = new FormData();
    Object.keys(data).map((val) => {
      formData.append(val, data[val]);
    });
    dispatch(postAddVehicle(formData));
   
  };

  useEffect(() => {
    if (postAddVehicleSuccess) {
      setShowOtherComponent(true);
    }else{
      setShowOtherComponent(false);
    }
  }, [postAddVehicleSuccess]);

  const addVehicle = () => {
    setOpen(true)
    setShowOtherComponent(false);
  }

  const handleClose = () => {
    setOpen(false);
  };

  const onDialog = (data, code) => {
    onSubmit(data, code)
      setOpen(true)
   
  };


  return (
    <Grid container>

      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={props?.value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item xs={8}>
                <TabList
                  className='minHeight32'
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    style: { backgroundColor: 'white' }, // Replace 'none' with your desired color
                  }}
                >
                  <Tab label="Matrix " value="matrix" className="tabStyle" />
                  <Tab label="Ticket" value="ticket" className="tabStyle" />
                  <Tab label="More Details" value="moreDetails" className="tabStyle" />
                  {props?.driverVehicleId && <Tab label="Vehicle Info" value="Vehicle" className="tabStyle" />}
                </TabList>
              </Grid>
              {props?.driverVehicleId? "" :(status === 'Active' && <Grid item container xs={4} direction='row' justifyContent='flex-end'><Button className='btnSubvendor' onClick={() => addVehicle()}>Vehicle +</Button></Grid>)}
            </Grid>
            <TabPanel value="matrix" className='vendotTable tabPanelStyle' sx={{ width: '100%' }}>
              {props?.loaderDriverMatrix ? <Loader/> :(
              <MatrixDriverVendor matrix={matrixDriverData(props.details, props?.tabDetails?.matrixData)} />)}
            </TabPanel>
            <TabPanel value="ticket" className='vendotTable tabPanelStyle'> 
            {props?.loaderDriverTicket? <Loader/> : (<CommonTable data={props?.tabDetails?.ticketData} handleChangePage={props?.handleChangePage}
          handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
          page={props?.page}
          isClickable = {false}
          rowsPerPage={props?.rowsPerPage}/> )}</TabPanel>
            <TabPanel value="moreDetails" className='vendotTable tabPanelStyle'>
             {props?.loaderDriverMoreDetails ? <Loader/> : ( <MoreDetails details={props?.tabDetails?.moreDetailsData} />)}
            </TabPanel>
            <TabPanel value="Vehicle" className='vendotTable tabPanelStyle'> 
            {/* TODO need to change or remove this data */}
              {/* <CommonTable 
                data={props?.tabDetails?.vehicleData} 
                handleChangePage={props?.handleChangePage}
                handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
                page={props?.page}
                rowsPerPage={props?.rowsPerPage}
                onClickTableVendor={props?.onClickTableVendor}
                onClickMoreIcon={props?.onClickMoreIcon}
              /> */}
              {props?.loaderDriverVehicleData ? <Loader/> : (
              <VehicleInfo vehicleInfo={props?.vehicleInfo} vehicleImage={props?.vehicleMoreData} amenitiesVehicle={props?.amenitiesVehicle} vehicleMoreData={props?.vehicleMoreData} vehicleMatrixData={props?.vehicleMatrixData} addVehicle={addVehicle} carOption={carOption} driverVehicleId={props?.driverVehicleId} />)}
          </TabPanel>
          </TabContext>
        </Box>
      </Grid>
      {open && (
        <CommonMultiImageForm
          open={open}
          handleClose={handleClose}
          formData={vehicleDialogData(carOption)}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          setOpen={false}
          selectType={'Create'}
          type={ 'Vehicle' + ' '}
          onImageChange={onImageChange}
          tabName ={'vehicle'}
          showOtherComponent={showOtherComponent}
        />
      )}
    </Grid>
  );
}

export default TabDriverVendor;